// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-date-range/dist/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-date-range/dist/theme/default.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-international-phone/dist/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-country-state-city/dist/react-country-state-city.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

#app-container {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

* {
  box-sizing: border-box;
  outline: none;
}

.floating-panel-root {
  border-top-left-radius: 0.1875rem;
  border-top-right-radius: 0.1875rem;
  background-color: white;
  z-index: 100000;
}

.floating-panel-root.has-border {
  box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
  -webkit-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);
}

.react-draggable {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hideFadeOut {
  animation: fadeOutDownTop 400ms forwards !important;
}

.test-only-trigger {
  position: fixed !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  border: 0 !important;
  opacity: 0 !important; /* Invisible pour l'œil */
  pointer-events: all !important; /* Important : doit rester cliquable */
  overflow: hidden !important;
}
`, "",{"version":3,"sources":["webpack://./../src/resources/css/main.css"],"names":[],"mappings":"AAKA;EACE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW;EACtC,wBAAwB,EAAE,mBAAmB;EAC7C,sBAAsB,EAAE,4BAA4B;EACpD,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB,EAAE,iFAAiF;AACtG;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB,EAAE,yBAAyB;EAChD,8BAA8B,EAAE,sCAAsC;EACtE,2BAA2B;AAC7B","sourcesContent":["@import \"react-date-range/dist/styles.css\";\n@import \"react-date-range/dist/theme/default.css\";\n@import \"react-international-phone/style.css\";\n@import \"react-country-state-city/dist/react-country-state-city.css\";\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n}\n\n#app-container {\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n  height: 100%;\n  min-height: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n* {\n  box-sizing: border-box;\n  outline: none;\n}\n\n.floating-panel-root {\n  border-top-left-radius: 0.1875rem;\n  border-top-right-radius: 0.1875rem;\n  background-color: white;\n  z-index: 100000;\n}\n\n.floating-panel-root.has-border {\n  box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n  -webkit-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n  -moz-box-shadow: 0px 0px 13px -2px rgba(0, 0, 0, 0.8);\n}\n\n.react-draggable {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hideFadeOut {\n  animation: fadeOutDownTop 400ms forwards !important;\n}\n\n.test-only-trigger {\n  position: fixed !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  border: 0 !important;\n  opacity: 0 !important; /* Invisible pour l'œil */\n  pointer-events: all !important; /* Important : doit rester cliquable */\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
